<template>
    <ContextMenuPanel ref="panel">
        <template v-slot:buttons>
            <slot name="buttons" />
        </template>
    </ContextMenuPanel>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-facing-decorator';
    import ContextMenuPanel from "./ContextMenuPanel.vue";

    @Component({ name: "ContextMenuFlyout", components: { ContextMenuPanel } })
    export default class ContextMenuFlyout extends Vue {
        @Prop() ParentRect!: DOMRect;

        mounted() {
            var panel = this.$refs.panel as any;
            var viewportOffset = panel.BoundingClientRect as DOMRect;
            var width = viewportOffset.width;
            var height = viewportOffset.height;

            var screenWidth = window.innerWidth;
            var screenHeight = window.innerHeight;

            var dx = this.ParentRect.right;
            var dy = this.ParentRect.top;

            if (dx + width + 5 > screenWidth)
                dx = this.ParentRect.left - width;
            if (dy + height + 5 > screenHeight)
                dy = screenHeight - height - 5;

            panel.Open(dx, dy);
        }
    }
</script>

<style>
</style>
